import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { v4 as uuidV4 } from 'uuid';
import { CbreHttpConfig, CbreHttpConfigToken } from '../cbre-http.config';
import { CBRE_UUID5_NS } from '../utils/constants';
import { HttpTransactionalClient } from './http-transactional-client.service';

/**
 * Creates an instance of a TransactionalHttpClient which binds a uuid to every request
 * made with it
 */
@Injectable({ providedIn: 'root' })
export class HttpTransactionalClientFactory {
  constructor(
    private http: HttpClient,
    @Inject(CbreHttpConfigToken) private options?: CbreHttpConfig
  ) {}

  /**
   * creates a new transactional client with fresh uuid every time it's called
   */
  public getTransactionalClient(): HttpTransactionalClient {
    return new HttpTransactionalClient(this.http, uuidV4(CBRE_UUID5_NS), this.options);
  }
}
